import { createSlice } from "@reduxjs/toolkit";
import { loadOrganizationData } from "./organizationActions";

interface OrganizationState {
  loading: boolean;
  organizationData: object | null;
  error: string | unknown;
  success: boolean;
}

const initialState: OrganizationState = {
  loading: false,
  organizationData: null,
  error: null,
  success: false,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    organizationDataRequested: (state) => {
      state.loading = true;
    },
    organizationDataUpdated: (state, action) => {
      state.organizationData = action.payload;
    },
    organizationDataCleared: (state) => {
      state.organizationData = null;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadOrganizationData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loadOrganizationData.fulfilled, (state, action) => {
      state.loading = false;
      state.organizationData = action.payload;
    });
    builder.addCase(loadOrganizationData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const {
  organizationDataRequested,
  organizationDataUpdated,
  organizationDataCleared,
} = organizationSlice.actions;

export default organizationSlice.reducer;
